
import { Options, prop, Vue } from "vue-class-component";

class Props {
  modelValue = prop<any>({
    required: true
  });
  summary = prop<any>({
    required: true
  });
}

@Options({
  emits: [
    "update:modelValue",
    "change"
  ]
})
export default class TabFilter extends Vue.with(Props) {
  
  filterOptions = [
    { label: "Semua", value: ""},
    { label: "Pesanan baru", value: "ORDWTC"},
    { label: "Diproses", value: "ORDPRC"},
    { label: "Perlu dikirim", value: "ORDBKD"},
    { label: "Dikirim", value: "ORDDLV"},
    { label: "Selesai", value: "ORDRCV"},
    { label: "Dibatalkan", value: "CNCWRF"}
  ]

  onSelectFilter(filter: string) {
    this.$emit("update:modelValue", filter);
    this.$emit("change", filter);
  }

  filterCounter(value: any) {
    const counter = value ? this.summary[value] : Object.values(this.summary).reduce((acc: any, curr: any) => acc + curr, 0)
    return `(${counter || 0})`
  }

}
